module.exports = __webpack_public_path__ + "themes/mf/img/prize-5@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-5@2x.png
// module id = 95
// module chunks = 3